export default __webpack_public_path__ + "static/media/teachings_of_prosperity.10995441.png";